/**
 * Custom behaviour for the carousel.
 * Extends the default carousel.
 *
 * @class ProductCarousel
 * @extends Carousel
 *
 * @requires components/carousel
 */

define('libs/carousel.custom',['require','libs/carousel','libs/utilities.throttle'],function(require) {

    'use strict';

    var _carousel = require('libs/carousel'),
        _throttle = require('libs/utilities.throttle');

    /** @constructor */
    var ProductCarousel = function() {
        this.init.apply(this, arguments);
    };

    // Make this custom carousel extend the default carousel.
    ProductCarousel.prototype = $.extend({}, _carousel.prototype, {
        /**
         * Find the controls and attach event handlers.
         * @memberof ProductCarousel
         */
        addControls: function() {
            // initialize the next-prev controls.
            var btnNext = $('.product-carousel-nav.left', this.container),
                btnPrev = $('.product-carousel-nav.right', this.container);

            if (btnNext) {
                btnNext.on(this.settings.touch ? 'touchend' : 'click', function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    this.scrollNext();
                }.bind(this));
            }
            if (btnPrev) {
                btnPrev.on(this.settings.touch ? 'touchend' : 'click', function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    this.scrollPrev();
                }.bind(this));
            }

            // navigate by moving the cursor left or right on the carousel.
            this.container.on('mousemove', this.onMouseMove.bind(this));
            this.container.on('mouseleave', function(){
                if (this.automover) {
                    clearInterval(this.automover);
                    this.automover = null;
                }
            }.bind(this));
        },

        onMouseMove: function(event) {
            var rect = this.container[0].getBoundingClientRect(),
                right = rect.right - event.originalEvent.clientX,
                left = event.originalEvent.clientX - rect.left;

            if (!this.automover && right <= 200) {
                this.automover = setInterval(this.next.bind(this), this.settings.animationTime / 2)
            } else if (!this.automover && left <= 200) {
                this.automover = setInterval(this.prev.bind(this), this.settings.animationTime / 2)
            } else if (this.automover && left > 200 && right > 200) {
                clearInterval(this.automover);
                this.automover = null;
            }
        },

        onResize: function() {
            // set the width or height of the element to the collective width/height of it's children.
            var property = this.settings.axis == 'x' ? 'width' : 'height';
            this.listSize = this.getContentSize();
            // apply the full size to the element.
            this.$element.css(property, this.listSize + 'px');
        }
    });

    return ProductCarousel;
});

